import React, { useEffect, useRef, useState } from "react";
import { SOCKET_URL } from '../../../config';

function MyWebRTC() {
    const peerConnection = useRef(null);
    const audioStream = useRef(null);
    const [isConnected, setIsConnected] = useState(false);
    const signalingServer = useRef(null);

    useEffect(() => {
        // Signaling 서버(WebSocket) 연결
        signalingServer.current = new WebSocket(`${SOCKET_URL}/ws`);

        signalingServer.current.onopen = () => {
            console.log("Connected to signaling server");
        };

        signalingServer.current.onmessage = async (event) => {
            const message = JSON.parse(event.data);
            if (message.type === "answer") {
                await peerConnection.current.setRemoteDescription(new RTCSessionDescription(message));
                setIsConnected(true);
            } else if (message.type === "ice-candidate") {
                await peerConnection.current.addIceCandidate(new RTCIceCandidate(message.candidate));
            }
        };

        signalingServer.current.onerror = (error) => {
            console.error("WebSocket error: ", error);
        };

        signalingServer.current.onclose = () => {
            console.log("Signaling server disconnected");
            setIsConnected(false);
        };

        return () => {
            signalingServer.current.close();
        };
    }, []);

    const startStreaming = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ 
                audio: { 
                    sampleRate: 48000,  // Opus 기본 샘플링 레이트
                    channelCount: 1
                } 
            });
            audioStream.current = stream;

            peerConnection.current = new RTCPeerConnection({
                iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
            });

            stream.getTracks().forEach(track => peerConnection.current.addTrack(track, stream));

            peerConnection.current.onicecandidate = (event) => {
                if (event.candidate) {
                    signalingServer.current.send(JSON.stringify({ type: "ice-candidate", candidate: event.candidate }));
                }
            };

            const offer = await peerConnection.current.createOffer();
            await peerConnection.current.setLocalDescription(offer);

            signalingServer.current.send(JSON.stringify({ type: "offer", sdp: offer.sdp }));

        } catch (error) {
            console.error("Error accessing microphone:", error);
        }
    };

    const stopStreaming = () => {
        if (audioStream.current) {
            audioStream.current.getTracks().forEach(track => track.stop());
        }
        if (peerConnection.current) {
            peerConnection.current.close();
            peerConnection.current = null;
        }
        setIsConnected(false);
    };

    return (
        <div>
            <h2>WebRTC Audio Streaming (Opus Codec)</h2>
            <button onClick={startStreaming} disabled={isConnected}>
                Start Streaming
            </button>
            <button onClick={stopStreaming} disabled={!isConnected}>
                Stop Streaming
            </button>
        </div>
    );
};

export default MyWebRTC;
